import { numberFormat } from '@/utils/helpers';
import { Button } from '@montugroup/design-system';
import AddIcon from '@mui/icons-material/Add';
import { MobileOnlySticky } from '../../../pages/escript/order-medication/OrderMedication.style';
import { OrderSummaryButton } from '../../../pages/escript/order-medication/OrderSummaryButton';
import type { MobileOrderActionsProps } from './types';

export function MobileOrderActions({
  viewState,
  checkoutData,
  isCheckoutDisabled,
  onAddNewScript,
  onCheckout,
}: MobileOrderActionsProps) {
  const handleAddNewScriptClick = (event: React.MouseEvent) => {
    event.preventDefault();
    onAddNewScript();
  };

  // Only show mobile actions for specific view states
  if (viewState === 'loading' || viewState === 'error') {
    return null;
  }

  return (
    <MobileOnlySticky>
      {viewState === 'reviewNewScript' && (
        <Button
          component="button"
          variant="outlined"
          size="large"
          color="primary"
          startIcon={<AddIcon />}
          data-testid="add-new-script-button"
          onClick={handleAddNewScriptClick}
        >
          Add new script
        </Button>
      )}

      {viewState === 'orderMedication' && (
        <>
          <Button
            component="button"
            variant="outlined"
            size="large"
            color="primary"
            startIcon={<AddIcon />}
            data-testid="add-new-script-button"
            onClick={handleAddNewScriptClick}
          >
            Add new script
          </Button>
          <OrderSummaryButton
            totalNumberOfProducts={checkoutData.totalNumberOfProducts}
            onClick={onCheckout}
            amount={numberFormat(checkoutData.totalPrice)}
            disabled={isCheckoutDisabled}
          />
        </>
      )}
    </MobileOnlySticky>
  );
}
